/**
 * @generated SignedSource<<364aa327ae098b07a3d0369bf0ce6b7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoteRowFragment$data = {
  readonly executor: {
    readonly address: {
      readonly address: string;
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
  };
  readonly id: string;
  readonly reason: string;
  readonly voter: {
    readonly address: {
      readonly address: string;
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
  };
  readonly votes: {
    readonly amount: {
      readonly amount: string;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"VoteReasonFragment" | "VoteRowTextFragment">;
  readonly " $fragmentType": "VoteRowFragment";
};
export type VoteRowFragment$key = {
  readonly " $data"?: VoteRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoteRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ResolvedName",
        "kind": "LinkedField",
        "name": "resolvedName",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NounResolvedLinkFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoteRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "amount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "voter",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "executor",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteRowTextFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteReasonFragment"
    }
  ],
  "type": "Vote",
  "abstractKey": null
};
})();

(node as any).hash = "74004a5843e03902ee8e936449fac907";

export default node;
